import { render, staticRenderFns } from "./ReleaseArticles.vue?vue&type=template&id=26957745&scoped=true"
import script from "./ReleaseArticles.vue?vue&type=script&lang=js"
export * from "./ReleaseArticles.vue?vue&type=script&lang=js"
import style0 from "./ReleaseArticles.vue?vue&type=style&index=0&id=26957745&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26957745",
  null
  
)

export default component.exports